import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-15hgbkp-0"
})(["display:flex;flex-flow:column;width:100%;span{", ";margin-bottom:4px;}img{width:30px;height:30px;}"], getFont('-2'));